/**
 * The media-gallery configuration the `featured-product` buy-box ships with — VERBATIM the `main-product`
 * preset's gallery settings (the Shrine above-the-fold look: thumbnails below the main image on desktop AND
 * mobile, no overlay arrows, un-cropped `contain` fit, square frame), so a featured product's media reads
 * exactly like the product page.
 *
 * It lives in this REACT-FREE module (not in `schema.ts`, which pulls every child block's schema — and with
 * them React) because `document/hydrate.ts` reuses it for the v3 → v4 upgrade and must stay React-free.
 */
export const FEATURED_GALLERY_SETTINGS = {
    mediaFit: 'contain',
    aspectRatio: 'square',
    galleryLayout: 'thumbnail_slider',
    thumbnailPosition: 'bottom',
    desktopArrowsPosition: 'hidden',
    mobileArrowsPosition: 'hidden',
    transparentArrows: true,
    mobileThumbnailsPosition: 'bottom',
};
/** The featured-product schema version that introduced the gallery media slot (see the upgrade in hydrate). */
export const FEATURED_PRODUCT_GALLERY_VERSION = 4;
//# sourceMappingURL=gallery.js.map